export default "__VITE_ASSET__B2xzr_WG__"